import React from "react";

const categoryContent = {
    insecticides: {
        title: "Insecticide Solutions",
        text: "Effective control against crop damaging insects with safe and reliable formulations.",
        image: "/images/img/insecticide.jpg",
    },
    fungicides: {
        title: "Fungicide Solutions",
        text: "Advanced protection against fungal diseases for healthier crops and better yield.",
        image: "/images/img/fungicide.jpg",
    },
    herbicides: {
        title: "Herbicide Solutions",
        text: "Efficient weed management solutions to support strong crop establishment.",
        image: "/images/img/herbicide.jpg",
    },
    fertilizers: {
        title: "Fertilizer Solutions",
        text: "Balanced plant nutrition to improve soil fertility and crop productivity.",
        image: "/images/img/fertilizer.jpg",
    },
    "plant-growth-regulators": {
        title: "Plant Growth Regulators",
        text: "Enhancing root development, flowering, and overall crop performance.",
        image: "/images/img/pgr.jpg",
    },
    "NPK-Fertilizer": {
        title: "NPK Fertilizers",
        text: "Providing balanced Nitrogen, Phosphorus, and Potassium nutrition to support healthy growth, strong roots, and higher crop yields.",
        image: "/images/img/npk.jpg",
    },
};

const CategoryHero = ({ categorySlug }) => {
    const data = categoryContent[categorySlug];

    if (!data) return null;

    return (
        <section
            className="category-hero"
            style={{
                backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${data.image})`,
            }}
        >
            <div className="category-hero-content">
                <h1>{data.title}</h1>
                <p>{data.text}</p>
            </div>
        </section>
    );
};

export default CategoryHero;
